export const YOUTUBE_DATA_API_V3 = "https://www.googleapis.com/youtube/v3";
export const JUNTOS_BACKEND_BASE_URL = "https://juntos-backend1.herokuapp.com";
